class LqAccordion extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.animation = null;
    this.isExpanding = false;
    this.isCollapsing = false;
  }

  connectedCallback() {
    if (!this.details || !this.summary || !this.content) return;

    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.details.style.overflow = 'hidden';

    if (this.isCollapsing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.close();
    }
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.details.scrollHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 400, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' }
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  close() {
    this.isCollapsing = true;
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 400, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isCollapsing = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isExpanding = false;
    this.isCollapsing = false;
    this.details.style.height = '';
    this.details.style.overflow = '';
  }
}

if (!customElements.get('lq-accordion')) {
  customElements.define('lq-accordion', LqAccordion);
}
